import { createSelector } from 'reselect';
import { MeloAttributeStateType } from './meloAttribute.types';

const getSubState = (state: any) => state.meloAttribute as MeloAttributeStateType;

const isSaving = createSelector(getSubState, (s) => s?.saving ?? false);
const hasError = createSelector(getSubState, (s) => s?.error ?? false);
const hasConflict = createSelector(getSubState, (s) => s?.conflict ?? false);
const hasStale = createSelector(getSubState, (s) => s?.stale ?? false);

export default { isSaving, hasError, hasConflict, hasStale };
